import { registerQuery, registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
export const FLOW_BY_ID_FIELDNAME = 'automation_ui_management_flowById';
export const GET_FLOW_BY_ID = registerQuery({
  fieldName: FLOW_BY_ID_FIELDNAME,
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return http.get(`automationplatform/v1/hybrid/${flowId}`).catch(errorWithInfo => {
      reportError({
        error: errorWithInfo,
        tags: {}
      });
      throw errorWithInfo;
    });
  }
});
export const ENROLLMENT_CRITERIA_BATCH_BY_ID_FIELDNAME = 'automation_ui_management_enrollmentCriteriaBatchById';
export const GET_ENROLLMENT_CRITERIA_BATCH_BY_ID = registerQuery({
  fieldName: ENROLLMENT_CRITERIA_BATCH_BY_ID_FIELDNAME,
  args: ['flowIds'],
  fetcher({
    flowIds
  }) {
    return http.post(`automationplatform/v1/hybrid/enrollment-criteria/batch`, {
      data: {
        inputs: flowIds
      }
    }).catch(errorWithInfo => {
      reportError({
        error: errorWithInfo,
        tags: {}
      });
      throw errorWithInfo;
    });
  }
});
export const UPDATE_FLOW = registerMutation({
  fieldName: FLOW_BY_ID_FIELDNAME,
  args: ['flow', 'sourceApp'],
  fetcher({
    flow,
    sourceApp
  }) {
    return http.post(`automationplatform/v1/hybrid/batch?sourceapp=${sourceApp}`, {
      data: flow
    });
  }
});
export const GENERATE_DESCRIPTION_FIELD_NAME = 'automation_ui_management_generateDescription';
export const GENERATE_DESCRIPTION = registerMutation({
  fieldName: GENERATE_DESCRIPTION_FIELD_NAME,
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return http.post(`opshub-ai/v0/workflows-copilot/description/generate`, {
      data: {
        flowId
      },
      query: {
        regenerateExisting: 'true'
      }
    });
  }
});
export const GENERATE_NAME_FIELD_NAME = 'automation_ui_management_generateName';
export const GENERATE_NAME = registerMutation({
  fieldName: GENERATE_NAME_FIELD_NAME,
  args: ['flowId', 'version'],
  fetcher({
    flowId,
    version
  }) {
    return http.post(`opshub-ai/v0/workflows-copilot/name/generate`, {
      data: {
        workflowIdentifier: {
          flowId,
          version
        }
      }
    });
  }
});
export const RATE_DESCRIPTION_FIELD_NAME = 'automation_ui_management_rateDescription';
export const RATE_DESCRIPTION = registerMutation({
  fieldName: RATE_DESCRIPTION_FIELD_NAME,
  args: ['rating', 'feedback'],
  fetcher({
    descriptionId,
    rating,
    feedback
  }) {
    return http.post(`opshub-ai/v0/workflows-copilot/description/rate/${descriptionId}`, {
      data: {
        rating,
        feedback
      }
    });
  }
});
export const CLONE_FLOW_FIELD_NAME = 'automation_ui_management_cloneFlow';
export const CLONE_FLOW = registerMutation({
  fieldName: CLONE_FLOW_FIELD_NAME,
  args: ['flowId', 'version', 'name', 'sourceApp', 'frameworkFolderId'],
  fetcher: ({
    flowId,
    version,
    name,
    sourceApp,
    frameworkFolderId,
    businessUnitId
  }) => http.post(`automationplatform/v1/hybrid/revisions/${flowId}/${version}/clone`, {
    query: {
      newName: name,
      sourceApp,
      folderId: frameworkFolderId,
      // folderId query param only works for moving flows into framework folder system
      businessUnitId
    },
    timeout: 50000
  })
});
export const DELETE_FLOWS_FIELD_NAME = 'automation_ui_management_flows';
export const DELETE_FLOWS = registerMutation({
  fieldName: DELETE_FLOWS_FIELD_NAME,
  args: ['expectedNumberOfFlowsToDelete', 'crmSearchRequest', 'flowIdFlowSourcePairs', 'force'],
  fetcher: ({
    expectedNumberOfFlowsToDelete,
    crmSearchRequest,
    flowIdFlowSourcePairs,
    force = true
  }) => http.post(`automationplatform/v1/hybrid/batch-delete?sourceapp=${SourceApps.WORKFLOWS_APP}`, {
    data: {
      expectedNumberOfFlowsToDelete,
      crmSearchRequest,
      flows: flowIdFlowSourcePairs,
      force
    }
  })
});
export const UPDATE_FLOW_TEAM_ASSIGNMENT_FIELD_NAME = 'automation_ui_management_updateFlowTeamAssignment';
export const UPDATE_FLOW_TEAM_ASSIGNMENT = registerMutation({
  fieldName: UPDATE_FLOW_TEAM_ASSIGNMENT_FIELD_NAME,
  args: ['flowId', 'teamIds'],
  fetcher({
    flowId,
    teamIds
  }) {
    return http.put(`automationapps/v1/flows/${flowId}/teamIds`, {
      data: teamIds
    });
  }
});
export const FLOW_CRM_OBJECT_BY_ID_FIELDNAME = 'automation_ui_management_flowCrmObjectById';
export const UPDATE_FLOW_CRM_OBJECT = registerMutation({
  fieldName: FLOW_CRM_OBJECT_BY_ID_FIELDNAME,
  args: ['flowId', 'description'],
  fetcher({
    flowId,
    description
  }) {
    return http.patch(`automationapps/v1/flow-crm-objects/${flowId}`, {
      data: {
        description
      }
    });
  }
});